/**
 * @fileoverview gRPC-Web generated client stub for org.codetricks.construction.code.assistant.service
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.21.12
// source: api.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as plan_reviewer_pb from './plan.reviewer_pb'; // proto import: "plan.reviewer.proto"
import * as cat_graph_pb from './cat_graph_pb'; // proto import: "cat_graph.proto"
import * as finding_video_pb from './finding_video_pb'; // proto import: "finding_video.proto"
import * as icc_chapters_pb from './icc.chapters_pb'; // proto import: "icc.chapters.proto"
import * as page_scale_pb from './page_scale_pb'; // proto import: "page_scale.proto"
import * as api_pb from './api_pb'; // proto import: "api.proto"
import * as compliance_report_pb from './compliance_report_pb'; // proto import: "compliance_report.proto"


export class ArchitecturalPlanServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetArchitecturalPlan = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetArchitecturalPlan',
    grpcWeb.MethodType.UNARY,
    api_pb.GetArchitecturalPlanRequest,
    plan_reviewer_pb.ArchitecturalPlan,
    (request: api_pb.GetArchitecturalPlanRequest) => {
      return request.serializeBinary();
    },
    plan_reviewer_pb.ArchitecturalPlan.deserializeBinary
  );

  getArchitecturalPlan(
    request: api_pb.GetArchitecturalPlanRequest,
    metadata?: grpcWeb.Metadata | null): Promise<plan_reviewer_pb.ArchitecturalPlan>;

  getArchitecturalPlan(
    request: api_pb.GetArchitecturalPlanRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.ArchitecturalPlan) => void): grpcWeb.ClientReadableStream<plan_reviewer_pb.ArchitecturalPlan>;

  getArchitecturalPlan(
    request: api_pb.GetArchitecturalPlanRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.ArchitecturalPlan) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetArchitecturalPlan',
        request,
        metadata || {},
        this.methodDescriptorGetArchitecturalPlan,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetArchitecturalPlan',
    request,
    metadata || {},
    this.methodDescriptorGetArchitecturalPlan);
  }

  methodDescriptorGetArchitecturalPlanPage = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetArchitecturalPlanPage',
    grpcWeb.MethodType.UNARY,
    api_pb.GetArchitecturalPlanPageRequest,
    plan_reviewer_pb.ArchitecturalPlanPage,
    (request: api_pb.GetArchitecturalPlanPageRequest) => {
      return request.serializeBinary();
    },
    plan_reviewer_pb.ArchitecturalPlanPage.deserializeBinary
  );

  getArchitecturalPlanPage(
    request: api_pb.GetArchitecturalPlanPageRequest,
    metadata?: grpcWeb.Metadata | null): Promise<plan_reviewer_pb.ArchitecturalPlanPage>;

  getArchitecturalPlanPage(
    request: api_pb.GetArchitecturalPlanPageRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.ArchitecturalPlanPage) => void): grpcWeb.ClientReadableStream<plan_reviewer_pb.ArchitecturalPlanPage>;

  getArchitecturalPlanPage(
    request: api_pb.GetArchitecturalPlanPageRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.ArchitecturalPlanPage) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetArchitecturalPlanPage',
        request,
        metadata || {},
        this.methodDescriptorGetArchitecturalPlanPage,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetArchitecturalPlanPage',
    request,
    metadata || {},
    this.methodDescriptorGetArchitecturalPlanPage);
  }

  methodDescriptorGetArchitecturalPlanPagePdf = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetArchitecturalPlanPagePdf',
    grpcWeb.MethodType.UNARY,
    api_pb.GetArchitecturalPlanPageRequest,
    api_pb.GetArchitecturalPlanPagePdfResponse,
    (request: api_pb.GetArchitecturalPlanPageRequest) => {
      return request.serializeBinary();
    },
    api_pb.GetArchitecturalPlanPagePdfResponse.deserializeBinary
  );

  getArchitecturalPlanPagePdf(
    request: api_pb.GetArchitecturalPlanPageRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.GetArchitecturalPlanPagePdfResponse>;

  getArchitecturalPlanPagePdf(
    request: api_pb.GetArchitecturalPlanPageRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.GetArchitecturalPlanPagePdfResponse) => void): grpcWeb.ClientReadableStream<api_pb.GetArchitecturalPlanPagePdfResponse>;

  getArchitecturalPlanPagePdf(
    request: api_pb.GetArchitecturalPlanPageRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.GetArchitecturalPlanPagePdfResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetArchitecturalPlanPagePdf',
        request,
        metadata || {},
        this.methodDescriptorGetArchitecturalPlanPagePdf,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetArchitecturalPlanPagePdf',
    request,
    metadata || {},
    this.methodDescriptorGetArchitecturalPlanPagePdf);
  }

  methodDescriptorGetRegionHierarchy = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetRegionHierarchy',
    grpcWeb.MethodType.UNARY,
    api_pb.GetRegionHierarchyRequest,
    api_pb.GetRegionHierarchyResponse,
    (request: api_pb.GetRegionHierarchyRequest) => {
      return request.serializeBinary();
    },
    api_pb.GetRegionHierarchyResponse.deserializeBinary
  );

  getRegionHierarchy(
    request: api_pb.GetRegionHierarchyRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.GetRegionHierarchyResponse>;

  getRegionHierarchy(
    request: api_pb.GetRegionHierarchyRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.GetRegionHierarchyResponse) => void): grpcWeb.ClientReadableStream<api_pb.GetRegionHierarchyResponse>;

  getRegionHierarchy(
    request: api_pb.GetRegionHierarchyRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.GetRegionHierarchyResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetRegionHierarchy',
        request,
        metadata || {},
        this.methodDescriptorGetRegionHierarchy,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetRegionHierarchy',
    request,
    metadata || {},
    this.methodDescriptorGetRegionHierarchy);
  }

  methodDescriptorUpdateArchitecturalPlanPageMetadata = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/UpdateArchitecturalPlanPageMetadata',
    grpcWeb.MethodType.UNARY,
    api_pb.UpdateArchitecturalPlanPageMetadataRequest,
    api_pb.UpdateArchitecturalPlanPageMetadataResponse,
    (request: api_pb.UpdateArchitecturalPlanPageMetadataRequest) => {
      return request.serializeBinary();
    },
    api_pb.UpdateArchitecturalPlanPageMetadataResponse.deserializeBinary
  );

  updateArchitecturalPlanPageMetadata(
    request: api_pb.UpdateArchitecturalPlanPageMetadataRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.UpdateArchitecturalPlanPageMetadataResponse>;

  updateArchitecturalPlanPageMetadata(
    request: api_pb.UpdateArchitecturalPlanPageMetadataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.UpdateArchitecturalPlanPageMetadataResponse) => void): grpcWeb.ClientReadableStream<api_pb.UpdateArchitecturalPlanPageMetadataResponse>;

  updateArchitecturalPlanPageMetadata(
    request: api_pb.UpdateArchitecturalPlanPageMetadataRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.UpdateArchitecturalPlanPageMetadataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/UpdateArchitecturalPlanPageMetadata',
        request,
        metadata || {},
        this.methodDescriptorUpdateArchitecturalPlanPageMetadata,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/UpdateArchitecturalPlanPageMetadata',
    request,
    metadata || {},
    this.methodDescriptorUpdateArchitecturalPlanPageMetadata);
  }

  methodDescriptorGroomArchitecturalPlanPageMetadata = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GroomArchitecturalPlanPageMetadata',
    grpcWeb.MethodType.UNARY,
    api_pb.GroomArchitecturalPlanPageMetadataRequest,
    api_pb.GroomArchitecturalPlanPageMetadataResponse,
    (request: api_pb.GroomArchitecturalPlanPageMetadataRequest) => {
      return request.serializeBinary();
    },
    api_pb.GroomArchitecturalPlanPageMetadataResponse.deserializeBinary
  );

  groomArchitecturalPlanPageMetadata(
    request: api_pb.GroomArchitecturalPlanPageMetadataRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.GroomArchitecturalPlanPageMetadataResponse>;

  groomArchitecturalPlanPageMetadata(
    request: api_pb.GroomArchitecturalPlanPageMetadataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.GroomArchitecturalPlanPageMetadataResponse) => void): grpcWeb.ClientReadableStream<api_pb.GroomArchitecturalPlanPageMetadataResponse>;

  groomArchitecturalPlanPageMetadata(
    request: api_pb.GroomArchitecturalPlanPageMetadataRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.GroomArchitecturalPlanPageMetadataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GroomArchitecturalPlanPageMetadata',
        request,
        metadata || {},
        this.methodDescriptorGroomArchitecturalPlanPageMetadata,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GroomArchitecturalPlanPageMetadata',
    request,
    metadata || {},
    this.methodDescriptorGroomArchitecturalPlanPageMetadata);
  }

  methodDescriptorListArchitecturalPlanPages = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListArchitecturalPlanPages',
    grpcWeb.MethodType.UNARY,
    api_pb.ListArchitecturalPlanPagesRequest,
    api_pb.ListArchitecturalPlanPagesResponse,
    (request: api_pb.ListArchitecturalPlanPagesRequest) => {
      return request.serializeBinary();
    },
    api_pb.ListArchitecturalPlanPagesResponse.deserializeBinary
  );

  listArchitecturalPlanPages(
    request: api_pb.ListArchitecturalPlanPagesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.ListArchitecturalPlanPagesResponse>;

  listArchitecturalPlanPages(
    request: api_pb.ListArchitecturalPlanPagesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.ListArchitecturalPlanPagesResponse) => void): grpcWeb.ClientReadableStream<api_pb.ListArchitecturalPlanPagesResponse>;

  listArchitecturalPlanPages(
    request: api_pb.ListArchitecturalPlanPagesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.ListArchitecturalPlanPagesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListArchitecturalPlanPages',
        request,
        metadata || {},
        this.methodDescriptorListArchitecturalPlanPages,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListArchitecturalPlanPages',
    request,
    metadata || {},
    this.methodDescriptorListArchitecturalPlanPages);
  }

  methodDescriptorListArchitecturalPlanIds = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListArchitecturalPlanIds',
    grpcWeb.MethodType.UNARY,
    api_pb.ListArchitecturalPlanIdsRequest,
    plan_reviewer_pb.ArchitecturalPlanIdList,
    (request: api_pb.ListArchitecturalPlanIdsRequest) => {
      return request.serializeBinary();
    },
    plan_reviewer_pb.ArchitecturalPlanIdList.deserializeBinary
  );

  listArchitecturalPlanIds(
    request: api_pb.ListArchitecturalPlanIdsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<plan_reviewer_pb.ArchitecturalPlanIdList>;

  listArchitecturalPlanIds(
    request: api_pb.ListArchitecturalPlanIdsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.ArchitecturalPlanIdList) => void): grpcWeb.ClientReadableStream<plan_reviewer_pb.ArchitecturalPlanIdList>;

  listArchitecturalPlanIds(
    request: api_pb.ListArchitecturalPlanIdsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.ArchitecturalPlanIdList) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListArchitecturalPlanIds',
        request,
        metadata || {},
        this.methodDescriptorListArchitecturalPlanIds,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListArchitecturalPlanIds',
    request,
    metadata || {},
    this.methodDescriptorListArchitecturalPlanIds);
  }

  methodDescriptorListArchitecturalProjectInputFiles = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListArchitecturalProjectInputFiles',
    grpcWeb.MethodType.UNARY,
    api_pb.ListArchitecturalProjectInputFilesRequest,
    api_pb.ListArchitecturalProjectInputFilesResponse,
    (request: api_pb.ListArchitecturalProjectInputFilesRequest) => {
      return request.serializeBinary();
    },
    api_pb.ListArchitecturalProjectInputFilesResponse.deserializeBinary
  );

  listArchitecturalProjectInputFiles(
    request: api_pb.ListArchitecturalProjectInputFilesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.ListArchitecturalProjectInputFilesResponse>;

  listArchitecturalProjectInputFiles(
    request: api_pb.ListArchitecturalProjectInputFilesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.ListArchitecturalProjectInputFilesResponse) => void): grpcWeb.ClientReadableStream<api_pb.ListArchitecturalProjectInputFilesResponse>;

  listArchitecturalProjectInputFiles(
    request: api_pb.ListArchitecturalProjectInputFilesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.ListArchitecturalProjectInputFilesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListArchitecturalProjectInputFiles',
        request,
        metadata || {},
        this.methodDescriptorListArchitecturalProjectInputFiles,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListArchitecturalProjectInputFiles',
    request,
    metadata || {},
    this.methodDescriptorListArchitecturalProjectInputFiles);
  }

  methodDescriptorGetProjectMetadata = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetProjectMetadata',
    grpcWeb.MethodType.UNARY,
    api_pb.GetProjectMetadataRequest,
    api_pb.GetProjectMetadataResponse,
    (request: api_pb.GetProjectMetadataRequest) => {
      return request.serializeBinary();
    },
    api_pb.GetProjectMetadataResponse.deserializeBinary
  );

  getProjectMetadata(
    request: api_pb.GetProjectMetadataRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.GetProjectMetadataResponse>;

  getProjectMetadata(
    request: api_pb.GetProjectMetadataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.GetProjectMetadataResponse) => void): grpcWeb.ClientReadableStream<api_pb.GetProjectMetadataResponse>;

  getProjectMetadata(
    request: api_pb.GetProjectMetadataRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.GetProjectMetadataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetProjectMetadata',
        request,
        metadata || {},
        this.methodDescriptorGetProjectMetadata,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetProjectMetadata',
    request,
    metadata || {},
    this.methodDescriptorGetProjectMetadata);
  }

  methodDescriptorCreateProjectMetadata = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/CreateProjectMetadata',
    grpcWeb.MethodType.UNARY,
    api_pb.CreateProjectMetadataRequest,
    api_pb.CreateProjectMetadataResponse,
    (request: api_pb.CreateProjectMetadataRequest) => {
      return request.serializeBinary();
    },
    api_pb.CreateProjectMetadataResponse.deserializeBinary
  );

  createProjectMetadata(
    request: api_pb.CreateProjectMetadataRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.CreateProjectMetadataResponse>;

  createProjectMetadata(
    request: api_pb.CreateProjectMetadataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.CreateProjectMetadataResponse) => void): grpcWeb.ClientReadableStream<api_pb.CreateProjectMetadataResponse>;

  createProjectMetadata(
    request: api_pb.CreateProjectMetadataRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.CreateProjectMetadataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/CreateProjectMetadata',
        request,
        metadata || {},
        this.methodDescriptorCreateProjectMetadata,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/CreateProjectMetadata',
    request,
    metadata || {},
    this.methodDescriptorCreateProjectMetadata);
  }

  methodDescriptorUpdateProjectMetadata = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/UpdateProjectMetadata',
    grpcWeb.MethodType.UNARY,
    api_pb.UpdateProjectMetadataRequest,
    api_pb.UpdateProjectMetadataResponse,
    (request: api_pb.UpdateProjectMetadataRequest) => {
      return request.serializeBinary();
    },
    api_pb.UpdateProjectMetadataResponse.deserializeBinary
  );

  updateProjectMetadata(
    request: api_pb.UpdateProjectMetadataRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.UpdateProjectMetadataResponse>;

  updateProjectMetadata(
    request: api_pb.UpdateProjectMetadataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.UpdateProjectMetadataResponse) => void): grpcWeb.ClientReadableStream<api_pb.UpdateProjectMetadataResponse>;

  updateProjectMetadata(
    request: api_pb.UpdateProjectMetadataRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.UpdateProjectMetadataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/UpdateProjectMetadata',
        request,
        metadata || {},
        this.methodDescriptorUpdateProjectMetadata,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/UpdateProjectMetadata',
    request,
    metadata || {},
    this.methodDescriptorUpdateProjectMetadata);
  }

  methodDescriptorGenerateInputFileMetadata = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GenerateInputFileMetadata',
    grpcWeb.MethodType.UNARY,
    api_pb.GenerateInputFileMetadataRequest,
    api_pb.GenerateInputFileMetadataResponse,
    (request: api_pb.GenerateInputFileMetadataRequest) => {
      return request.serializeBinary();
    },
    api_pb.GenerateInputFileMetadataResponse.deserializeBinary
  );

  generateInputFileMetadata(
    request: api_pb.GenerateInputFileMetadataRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.GenerateInputFileMetadataResponse>;

  generateInputFileMetadata(
    request: api_pb.GenerateInputFileMetadataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.GenerateInputFileMetadataResponse) => void): grpcWeb.ClientReadableStream<api_pb.GenerateInputFileMetadataResponse>;

  generateInputFileMetadata(
    request: api_pb.GenerateInputFileMetadataRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.GenerateInputFileMetadataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GenerateInputFileMetadata',
        request,
        metadata || {},
        this.methodDescriptorGenerateInputFileMetadata,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GenerateInputFileMetadata',
    request,
    metadata || {},
    this.methodDescriptorGenerateInputFileMetadata);
  }

  methodDescriptorGetInputFileMetadata = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetInputFileMetadata',
    grpcWeb.MethodType.UNARY,
    api_pb.GetInputFileMetadataRequest,
    api_pb.GetInputFileMetadataResponse,
    (request: api_pb.GetInputFileMetadataRequest) => {
      return request.serializeBinary();
    },
    api_pb.GetInputFileMetadataResponse.deserializeBinary
  );

  getInputFileMetadata(
    request: api_pb.GetInputFileMetadataRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.GetInputFileMetadataResponse>;

  getInputFileMetadata(
    request: api_pb.GetInputFileMetadataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.GetInputFileMetadataResponse) => void): grpcWeb.ClientReadableStream<api_pb.GetInputFileMetadataResponse>;

  getInputFileMetadata(
    request: api_pb.GetInputFileMetadataRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.GetInputFileMetadataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetInputFileMetadata',
        request,
        metadata || {},
        this.methodDescriptorGetInputFileMetadata,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetInputFileMetadata',
    request,
    metadata || {},
    this.methodDescriptorGetInputFileMetadata);
  }

  methodDescriptorListInputFileMetadata = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListInputFileMetadata',
    grpcWeb.MethodType.UNARY,
    api_pb.ListInputFileMetadataRequest,
    api_pb.ListInputFileMetadataResponse,
    (request: api_pb.ListInputFileMetadataRequest) => {
      return request.serializeBinary();
    },
    api_pb.ListInputFileMetadataResponse.deserializeBinary
  );

  listInputFileMetadata(
    request: api_pb.ListInputFileMetadataRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.ListInputFileMetadataResponse>;

  listInputFileMetadata(
    request: api_pb.ListInputFileMetadataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.ListInputFileMetadataResponse) => void): grpcWeb.ClientReadableStream<api_pb.ListInputFileMetadataResponse>;

  listInputFileMetadata(
    request: api_pb.ListInputFileMetadataRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.ListInputFileMetadataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListInputFileMetadata',
        request,
        metadata || {},
        this.methodDescriptorListInputFileMetadata,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListInputFileMetadata',
    request,
    metadata || {},
    this.methodDescriptorListInputFileMetadata);
  }

  methodDescriptorGetPageScaleCalibration = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetPageScaleCalibration',
    grpcWeb.MethodType.UNARY,
    page_scale_pb.GetPageScaleCalibrationRequest,
    page_scale_pb.PageScaleState,
    (request: page_scale_pb.GetPageScaleCalibrationRequest) => {
      return request.serializeBinary();
    },
    page_scale_pb.PageScaleState.deserializeBinary
  );

  getPageScaleCalibration(
    request: page_scale_pb.GetPageScaleCalibrationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<page_scale_pb.PageScaleState>;

  getPageScaleCalibration(
    request: page_scale_pb.GetPageScaleCalibrationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: page_scale_pb.PageScaleState) => void): grpcWeb.ClientReadableStream<page_scale_pb.PageScaleState>;

  getPageScaleCalibration(
    request: page_scale_pb.GetPageScaleCalibrationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: page_scale_pb.PageScaleState) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetPageScaleCalibration',
        request,
        metadata || {},
        this.methodDescriptorGetPageScaleCalibration,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/GetPageScaleCalibration',
    request,
    metadata || {},
    this.methodDescriptorGetPageScaleCalibration);
  }

  methodDescriptorListPageScaleCalibrationHistory = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListPageScaleCalibrationHistory',
    grpcWeb.MethodType.UNARY,
    page_scale_pb.ListPageScaleCalibrationHistoryRequest,
    page_scale_pb.ListPageScaleCalibrationHistoryResponse,
    (request: page_scale_pb.ListPageScaleCalibrationHistoryRequest) => {
      return request.serializeBinary();
    },
    page_scale_pb.ListPageScaleCalibrationHistoryResponse.deserializeBinary
  );

  listPageScaleCalibrationHistory(
    request: page_scale_pb.ListPageScaleCalibrationHistoryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<page_scale_pb.ListPageScaleCalibrationHistoryResponse>;

  listPageScaleCalibrationHistory(
    request: page_scale_pb.ListPageScaleCalibrationHistoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: page_scale_pb.ListPageScaleCalibrationHistoryResponse) => void): grpcWeb.ClientReadableStream<page_scale_pb.ListPageScaleCalibrationHistoryResponse>;

  listPageScaleCalibrationHistory(
    request: page_scale_pb.ListPageScaleCalibrationHistoryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: page_scale_pb.ListPageScaleCalibrationHistoryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListPageScaleCalibrationHistory',
        request,
        metadata || {},
        this.methodDescriptorListPageScaleCalibrationHistory,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanService/ListPageScaleCalibrationHistory',
    request,
    metadata || {},
    this.methodDescriptorListPageScaleCalibrationHistory);
  }

}

export class ArchitecturalPlanWriteServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCreateArchitecturalPlan = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/CreateArchitecturalPlan',
    grpcWeb.MethodType.UNARY,
    api_pb.CreateArchitecturalPlanRequest,
    api_pb.CreateArchitecturalPlanResponse,
    (request: api_pb.CreateArchitecturalPlanRequest) => {
      return request.serializeBinary();
    },
    api_pb.CreateArchitecturalPlanResponse.deserializeBinary
  );

  createArchitecturalPlan(
    request: api_pb.CreateArchitecturalPlanRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.CreateArchitecturalPlanResponse>;

  createArchitecturalPlan(
    request: api_pb.CreateArchitecturalPlanRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.CreateArchitecturalPlanResponse) => void): grpcWeb.ClientReadableStream<api_pb.CreateArchitecturalPlanResponse>;

  createArchitecturalPlan(
    request: api_pb.CreateArchitecturalPlanRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.CreateArchitecturalPlanResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/CreateArchitecturalPlan',
        request,
        metadata || {},
        this.methodDescriptorCreateArchitecturalPlan,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/CreateArchitecturalPlan',
    request,
    metadata || {},
    this.methodDescriptorCreateArchitecturalPlan);
  }

  methodDescriptorUploadFileToProject = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/UploadFileToProject',
    grpcWeb.MethodType.UNARY,
    api_pb.UploadFileToProjectRequest,
    api_pb.UploadFileToProjectResponse,
    (request: api_pb.UploadFileToProjectRequest) => {
      return request.serializeBinary();
    },
    api_pb.UploadFileToProjectResponse.deserializeBinary
  );

  uploadFileToProject(
    request: api_pb.UploadFileToProjectRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.UploadFileToProjectResponse>;

  uploadFileToProject(
    request: api_pb.UploadFileToProjectRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.UploadFileToProjectResponse) => void): grpcWeb.ClientReadableStream<api_pb.UploadFileToProjectResponse>;

  uploadFileToProject(
    request: api_pb.UploadFileToProjectRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.UploadFileToProjectResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/UploadFileToProject',
        request,
        metadata || {},
        this.methodDescriptorUploadFileToProject,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/UploadFileToProject',
    request,
    metadata || {},
    this.methodDescriptorUploadFileToProject);
  }

  methodDescriptorIngestFileIntoProject = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/IngestFileIntoProject',
    grpcWeb.MethodType.UNARY,
    api_pb.IngestFileIntoProjectRequest,
    api_pb.IngestFileIntoProjectResponse,
    (request: api_pb.IngestFileIntoProjectRequest) => {
      return request.serializeBinary();
    },
    api_pb.IngestFileIntoProjectResponse.deserializeBinary
  );

  ingestFileIntoProject(
    request: api_pb.IngestFileIntoProjectRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.IngestFileIntoProjectResponse>;

  ingestFileIntoProject(
    request: api_pb.IngestFileIntoProjectRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.IngestFileIntoProjectResponse) => void): grpcWeb.ClientReadableStream<api_pb.IngestFileIntoProjectResponse>;

  ingestFileIntoProject(
    request: api_pb.IngestFileIntoProjectRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.IngestFileIntoProjectResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/IngestFileIntoProject',
        request,
        metadata || {},
        this.methodDescriptorIngestFileIntoProject,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/IngestFileIntoProject',
    request,
    metadata || {},
    this.methodDescriptorIngestFileIntoProject);
  }

  methodDescriptorGenerateUploadUrl = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/GenerateUploadUrl',
    grpcWeb.MethodType.UNARY,
    api_pb.GenerateUploadUrlRequest,
    api_pb.GenerateUploadUrlResponse,
    (request: api_pb.GenerateUploadUrlRequest) => {
      return request.serializeBinary();
    },
    api_pb.GenerateUploadUrlResponse.deserializeBinary
  );

  generateUploadUrl(
    request: api_pb.GenerateUploadUrlRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.GenerateUploadUrlResponse>;

  generateUploadUrl(
    request: api_pb.GenerateUploadUrlRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.GenerateUploadUrlResponse) => void): grpcWeb.ClientReadableStream<api_pb.GenerateUploadUrlResponse>;

  generateUploadUrl(
    request: api_pb.GenerateUploadUrlRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.GenerateUploadUrlResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/GenerateUploadUrl',
        request,
        metadata || {},
        this.methodDescriptorGenerateUploadUrl,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/GenerateUploadUrl',
    request,
    metadata || {},
    this.methodDescriptorGenerateUploadUrl);
  }

  methodDescriptorNotifyUploadComplete = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/NotifyUploadComplete',
    grpcWeb.MethodType.UNARY,
    api_pb.NotifyUploadCompleteRequest,
    api_pb.NotifyUploadCompleteResponse,
    (request: api_pb.NotifyUploadCompleteRequest) => {
      return request.serializeBinary();
    },
    api_pb.NotifyUploadCompleteResponse.deserializeBinary
  );

  notifyUploadComplete(
    request: api_pb.NotifyUploadCompleteRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.NotifyUploadCompleteResponse>;

  notifyUploadComplete(
    request: api_pb.NotifyUploadCompleteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.NotifyUploadCompleteResponse) => void): grpcWeb.ClientReadableStream<api_pb.NotifyUploadCompleteResponse>;

  notifyUploadComplete(
    request: api_pb.NotifyUploadCompleteRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.NotifyUploadCompleteResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/NotifyUploadComplete',
        request,
        metadata || {},
        this.methodDescriptorNotifyUploadComplete,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/NotifyUploadComplete',
    request,
    metadata || {},
    this.methodDescriptorNotifyUploadComplete);
  }

  methodDescriptorCopyArchitecturalPlan = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/CopyArchitecturalPlan',
    grpcWeb.MethodType.UNARY,
    api_pb.CopyArchitecturalPlanRequest,
    api_pb.CopyArchitecturalPlanResponse,
    (request: api_pb.CopyArchitecturalPlanRequest) => {
      return request.serializeBinary();
    },
    api_pb.CopyArchitecturalPlanResponse.deserializeBinary
  );

  copyArchitecturalPlan(
    request: api_pb.CopyArchitecturalPlanRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.CopyArchitecturalPlanResponse>;

  copyArchitecturalPlan(
    request: api_pb.CopyArchitecturalPlanRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.CopyArchitecturalPlanResponse) => void): grpcWeb.ClientReadableStream<api_pb.CopyArchitecturalPlanResponse>;

  copyArchitecturalPlan(
    request: api_pb.CopyArchitecturalPlanRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.CopyArchitecturalPlanResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/CopyArchitecturalPlan',
        request,
        metadata || {},
        this.methodDescriptorCopyArchitecturalPlan,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/CopyArchitecturalPlan',
    request,
    metadata || {},
    this.methodDescriptorCopyArchitecturalPlan);
  }

  methodDescriptorDeleteArchitecturalPlan = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/DeleteArchitecturalPlan',
    grpcWeb.MethodType.UNARY,
    api_pb.DeleteArchitecturalPlanRequest,
    api_pb.DeleteArchitecturalPlanResponse,
    (request: api_pb.DeleteArchitecturalPlanRequest) => {
      return request.serializeBinary();
    },
    api_pb.DeleteArchitecturalPlanResponse.deserializeBinary
  );

  deleteArchitecturalPlan(
    request: api_pb.DeleteArchitecturalPlanRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.DeleteArchitecturalPlanResponse>;

  deleteArchitecturalPlan(
    request: api_pb.DeleteArchitecturalPlanRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.DeleteArchitecturalPlanResponse) => void): grpcWeb.ClientReadableStream<api_pb.DeleteArchitecturalPlanResponse>;

  deleteArchitecturalPlan(
    request: api_pb.DeleteArchitecturalPlanRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.DeleteArchitecturalPlanResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/DeleteArchitecturalPlan',
        request,
        metadata || {},
        this.methodDescriptorDeleteArchitecturalPlan,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/DeleteArchitecturalPlan',
    request,
    metadata || {},
    this.methodDescriptorDeleteArchitecturalPlan);
  }

  methodDescriptorDeleteInputFile = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/DeleteInputFile',
    grpcWeb.MethodType.UNARY,
    api_pb.DeleteInputFileRequest,
    api_pb.DeleteInputFileResponse,
    (request: api_pb.DeleteInputFileRequest) => {
      return request.serializeBinary();
    },
    api_pb.DeleteInputFileResponse.deserializeBinary
  );

  deleteInputFile(
    request: api_pb.DeleteInputFileRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.DeleteInputFileResponse>;

  deleteInputFile(
    request: api_pb.DeleteInputFileRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.DeleteInputFileResponse) => void): grpcWeb.ClientReadableStream<api_pb.DeleteInputFileResponse>;

  deleteInputFile(
    request: api_pb.DeleteInputFileRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.DeleteInputFileResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/DeleteInputFile',
        request,
        metadata || {},
        this.methodDescriptorDeleteInputFile,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/DeleteInputFile',
    request,
    metadata || {},
    this.methodDescriptorDeleteInputFile);
  }

  methodDescriptorRotateArchitecturalPlanPage = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/RotateArchitecturalPlanPage',
    grpcWeb.MethodType.UNARY,
    api_pb.RotateArchitecturalPlanPageRequest,
    api_pb.RotateArchitecturalPlanPageResponse,
    (request: api_pb.RotateArchitecturalPlanPageRequest) => {
      return request.serializeBinary();
    },
    api_pb.RotateArchitecturalPlanPageResponse.deserializeBinary
  );

  rotateArchitecturalPlanPage(
    request: api_pb.RotateArchitecturalPlanPageRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.RotateArchitecturalPlanPageResponse>;

  rotateArchitecturalPlanPage(
    request: api_pb.RotateArchitecturalPlanPageRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.RotateArchitecturalPlanPageResponse) => void): grpcWeb.ClientReadableStream<api_pb.RotateArchitecturalPlanPageResponse>;

  rotateArchitecturalPlanPage(
    request: api_pb.RotateArchitecturalPlanPageRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.RotateArchitecturalPlanPageResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/RotateArchitecturalPlanPage',
        request,
        metadata || {},
        this.methodDescriptorRotateArchitecturalPlanPage,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/RotateArchitecturalPlanPage',
    request,
    metadata || {},
    this.methodDescriptorRotateArchitecturalPlanPage);
  }

  methodDescriptorSetPageScaleCalibration = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/SetPageScaleCalibration',
    grpcWeb.MethodType.UNARY,
    page_scale_pb.SetPageScaleCalibrationRequest,
    page_scale_pb.PageScaleWriteResponse,
    (request: page_scale_pb.SetPageScaleCalibrationRequest) => {
      return request.serializeBinary();
    },
    page_scale_pb.PageScaleWriteResponse.deserializeBinary
  );

  setPageScaleCalibration(
    request: page_scale_pb.SetPageScaleCalibrationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<page_scale_pb.PageScaleWriteResponse>;

  setPageScaleCalibration(
    request: page_scale_pb.SetPageScaleCalibrationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: page_scale_pb.PageScaleWriteResponse) => void): grpcWeb.ClientReadableStream<page_scale_pb.PageScaleWriteResponse>;

  setPageScaleCalibration(
    request: page_scale_pb.SetPageScaleCalibrationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: page_scale_pb.PageScaleWriteResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/SetPageScaleCalibration',
        request,
        metadata || {},
        this.methodDescriptorSetPageScaleCalibration,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/SetPageScaleCalibration',
    request,
    metadata || {},
    this.methodDescriptorSetPageScaleCalibration);
  }

  methodDescriptorResetPageScaleCalibration = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/ResetPageScaleCalibration',
    grpcWeb.MethodType.UNARY,
    page_scale_pb.ResetPageScaleCalibrationRequest,
    page_scale_pb.PageScaleWriteResponse,
    (request: page_scale_pb.ResetPageScaleCalibrationRequest) => {
      return request.serializeBinary();
    },
    page_scale_pb.PageScaleWriteResponse.deserializeBinary
  );

  resetPageScaleCalibration(
    request: page_scale_pb.ResetPageScaleCalibrationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<page_scale_pb.PageScaleWriteResponse>;

  resetPageScaleCalibration(
    request: page_scale_pb.ResetPageScaleCalibrationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: page_scale_pb.PageScaleWriteResponse) => void): grpcWeb.ClientReadableStream<page_scale_pb.PageScaleWriteResponse>;

  resetPageScaleCalibration(
    request: page_scale_pb.ResetPageScaleCalibrationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: page_scale_pb.PageScaleWriteResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/ResetPageScaleCalibration',
        request,
        metadata || {},
        this.methodDescriptorResetPageScaleCalibration,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteService/ResetPageScaleCalibration',
    request,
    metadata || {},
    this.methodDescriptorResetPageScaleCalibration);
  }

}

export class ArchitecturalPlanReviewServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetApplicableCodeSections = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetApplicableCodeSections',
    grpcWeb.MethodType.UNARY,
    api_pb.GetApplicableCodeSectionsRequest,
    plan_reviewer_pb.PageApplicabilityAnalysisList,
    (request: api_pb.GetApplicableCodeSectionsRequest) => {
      return request.serializeBinary();
    },
    plan_reviewer_pb.PageApplicabilityAnalysisList.deserializeBinary
  );

  getApplicableCodeSections(
    request: api_pb.GetApplicableCodeSectionsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<plan_reviewer_pb.PageApplicabilityAnalysisList>;

  getApplicableCodeSections(
    request: api_pb.GetApplicableCodeSectionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.PageApplicabilityAnalysisList) => void): grpcWeb.ClientReadableStream<plan_reviewer_pb.PageApplicabilityAnalysisList>;

  getApplicableCodeSections(
    request: api_pb.GetApplicableCodeSectionsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.PageApplicabilityAnalysisList) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetApplicableCodeSections',
        request,
        metadata || {},
        this.methodDescriptorGetApplicableCodeSections,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetApplicableCodeSections',
    request,
    metadata || {},
    this.methodDescriptorGetApplicableCodeSections);
  }

  methodDescriptorGetIccBookTableOfContents = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetIccBookTableOfContents',
    grpcWeb.MethodType.UNARY,
    api_pb.GetIccBookTableOfContentsRequest,
    icc_chapters_pb.Chapters,
    (request: api_pb.GetIccBookTableOfContentsRequest) => {
      return request.serializeBinary();
    },
    icc_chapters_pb.Chapters.deserializeBinary
  );

  getIccBookTableOfContents(
    request: api_pb.GetIccBookTableOfContentsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<icc_chapters_pb.Chapters>;

  getIccBookTableOfContents(
    request: api_pb.GetIccBookTableOfContentsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: icc_chapters_pb.Chapters) => void): grpcWeb.ClientReadableStream<icc_chapters_pb.Chapters>;

  getIccBookTableOfContents(
    request: api_pb.GetIccBookTableOfContentsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: icc_chapters_pb.Chapters) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetIccBookTableOfContents',
        request,
        metadata || {},
        this.methodDescriptorGetIccBookTableOfContents,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetIccBookTableOfContents',
    request,
    metadata || {},
    this.methodDescriptorGetIccBookTableOfContents);
  }

  methodDescriptorGetPageSectionComplianceReport = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetPageSectionComplianceReport',
    grpcWeb.MethodType.UNARY,
    plan_reviewer_pb.GetPageSectionComplianceReportRequest,
    plan_reviewer_pb.PageSectionComplianceReport,
    (request: plan_reviewer_pb.GetPageSectionComplianceReportRequest) => {
      return request.serializeBinary();
    },
    plan_reviewer_pb.PageSectionComplianceReport.deserializeBinary
  );

  getPageSectionComplianceReport(
    request: plan_reviewer_pb.GetPageSectionComplianceReportRequest,
    metadata?: grpcWeb.Metadata | null): Promise<plan_reviewer_pb.PageSectionComplianceReport>;

  getPageSectionComplianceReport(
    request: plan_reviewer_pb.GetPageSectionComplianceReportRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.PageSectionComplianceReport) => void): grpcWeb.ClientReadableStream<plan_reviewer_pb.PageSectionComplianceReport>;

  getPageSectionComplianceReport(
    request: plan_reviewer_pb.GetPageSectionComplianceReportRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.PageSectionComplianceReport) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetPageSectionComplianceReport',
        request,
        metadata || {},
        this.methodDescriptorGetPageSectionComplianceReport,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetPageSectionComplianceReport',
    request,
    metadata || {},
    this.methodDescriptorGetPageSectionComplianceReport);
  }

  methodDescriptorGetPageComplianceReport = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetPageComplianceReport',
    grpcWeb.MethodType.UNARY,
    plan_reviewer_pb.GetPageComplianceReportRequest,
    plan_reviewer_pb.PageComplianceReport,
    (request: plan_reviewer_pb.GetPageComplianceReportRequest) => {
      return request.serializeBinary();
    },
    plan_reviewer_pb.PageComplianceReport.deserializeBinary
  );

  getPageComplianceReport(
    request: plan_reviewer_pb.GetPageComplianceReportRequest,
    metadata?: grpcWeb.Metadata | null): Promise<plan_reviewer_pb.PageComplianceReport>;

  getPageComplianceReport(
    request: plan_reviewer_pb.GetPageComplianceReportRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.PageComplianceReport) => void): grpcWeb.ClientReadableStream<plan_reviewer_pb.PageComplianceReport>;

  getPageComplianceReport(
    request: plan_reviewer_pb.GetPageComplianceReportRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.PageComplianceReport) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetPageComplianceReport',
        request,
        metadata || {},
        this.methodDescriptorGetPageComplianceReport,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetPageComplianceReport',
    request,
    metadata || {},
    this.methodDescriptorGetPageComplianceReport);
  }

  methodDescriptorGetFileComplianceSummary = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetFileComplianceSummary',
    grpcWeb.MethodType.UNARY,
    plan_reviewer_pb.GetFileComplianceSummaryRequest,
    plan_reviewer_pb.FileComplianceSummary,
    (request: plan_reviewer_pb.GetFileComplianceSummaryRequest) => {
      return request.serializeBinary();
    },
    plan_reviewer_pb.FileComplianceSummary.deserializeBinary
  );

  getFileComplianceSummary(
    request: plan_reviewer_pb.GetFileComplianceSummaryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<plan_reviewer_pb.FileComplianceSummary>;

  getFileComplianceSummary(
    request: plan_reviewer_pb.GetFileComplianceSummaryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.FileComplianceSummary) => void): grpcWeb.ClientReadableStream<plan_reviewer_pb.FileComplianceSummary>;

  getFileComplianceSummary(
    request: plan_reviewer_pb.GetFileComplianceSummaryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.FileComplianceSummary) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetFileComplianceSummary',
        request,
        metadata || {},
        this.methodDescriptorGetFileComplianceSummary,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetFileComplianceSummary',
    request,
    metadata || {},
    this.methodDescriptorGetFileComplianceSummary);
  }

  methodDescriptorListFileCompliancePages = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/ListFileCompliancePages',
    grpcWeb.MethodType.UNARY,
    plan_reviewer_pb.ListFileCompliancePagesRequest,
    plan_reviewer_pb.ListFileCompliancePagesResponse,
    (request: plan_reviewer_pb.ListFileCompliancePagesRequest) => {
      return request.serializeBinary();
    },
    plan_reviewer_pb.ListFileCompliancePagesResponse.deserializeBinary
  );

  listFileCompliancePages(
    request: plan_reviewer_pb.ListFileCompliancePagesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<plan_reviewer_pb.ListFileCompliancePagesResponse>;

  listFileCompliancePages(
    request: plan_reviewer_pb.ListFileCompliancePagesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.ListFileCompliancePagesResponse) => void): grpcWeb.ClientReadableStream<plan_reviewer_pb.ListFileCompliancePagesResponse>;

  listFileCompliancePages(
    request: plan_reviewer_pb.ListFileCompliancePagesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.ListFileCompliancePagesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/ListFileCompliancePages',
        request,
        metadata || {},
        this.methodDescriptorListFileCompliancePages,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/ListFileCompliancePages',
    request,
    metadata || {},
    this.methodDescriptorListFileCompliancePages);
  }

  methodDescriptorGetFileOverviewSummary = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetFileOverviewSummary',
    grpcWeb.MethodType.UNARY,
    plan_reviewer_pb.GetFileOverviewSummaryRequest,
    plan_reviewer_pb.FileOverviewSummary,
    (request: plan_reviewer_pb.GetFileOverviewSummaryRequest) => {
      return request.serializeBinary();
    },
    plan_reviewer_pb.FileOverviewSummary.deserializeBinary
  );

  getFileOverviewSummary(
    request: plan_reviewer_pb.GetFileOverviewSummaryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<plan_reviewer_pb.FileOverviewSummary>;

  getFileOverviewSummary(
    request: plan_reviewer_pb.GetFileOverviewSummaryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.FileOverviewSummary) => void): grpcWeb.ClientReadableStream<plan_reviewer_pb.FileOverviewSummary>;

  getFileOverviewSummary(
    request: plan_reviewer_pb.GetFileOverviewSummaryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.FileOverviewSummary) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetFileOverviewSummary',
        request,
        metadata || {},
        this.methodDescriptorGetFileOverviewSummary,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetFileOverviewSummary',
    request,
    metadata || {},
    this.methodDescriptorGetFileOverviewSummary);
  }

  methodDescriptorGetPlanComplianceReport = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetPlanComplianceReport',
    grpcWeb.MethodType.UNARY,
    plan_reviewer_pb.GetPlanComplianceReportRequest,
    plan_reviewer_pb.PlanComplianceReport,
    (request: plan_reviewer_pb.GetPlanComplianceReportRequest) => {
      return request.serializeBinary();
    },
    plan_reviewer_pb.PlanComplianceReport.deserializeBinary
  );

  getPlanComplianceReport(
    request: plan_reviewer_pb.GetPlanComplianceReportRequest,
    metadata?: grpcWeb.Metadata | null): Promise<plan_reviewer_pb.PlanComplianceReport>;

  getPlanComplianceReport(
    request: plan_reviewer_pb.GetPlanComplianceReportRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.PlanComplianceReport) => void): grpcWeb.ClientReadableStream<plan_reviewer_pb.PlanComplianceReport>;

  getPlanComplianceReport(
    request: plan_reviewer_pb.GetPlanComplianceReportRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: plan_reviewer_pb.PlanComplianceReport) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetPlanComplianceReport',
        request,
        metadata || {},
        this.methodDescriptorGetPlanComplianceReport,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/GetPlanComplianceReport',
    request,
    metadata || {},
    this.methodDescriptorGetPlanComplianceReport);
  }

  methodDescriptorStartPageSectionComplianceReportTask = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/StartPageSectionComplianceReportTask',
    grpcWeb.MethodType.UNARY,
    compliance_report_pb.StartPageSectionComplianceReportTaskRequest,
    compliance_report_pb.StartPageSectionComplianceReportTaskResponse,
    (request: compliance_report_pb.StartPageSectionComplianceReportTaskRequest) => {
      return request.serializeBinary();
    },
    compliance_report_pb.StartPageSectionComplianceReportTaskResponse.deserializeBinary
  );

  startPageSectionComplianceReportTask(
    request: compliance_report_pb.StartPageSectionComplianceReportTaskRequest,
    metadata?: grpcWeb.Metadata | null): Promise<compliance_report_pb.StartPageSectionComplianceReportTaskResponse>;

  startPageSectionComplianceReportTask(
    request: compliance_report_pb.StartPageSectionComplianceReportTaskRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: compliance_report_pb.StartPageSectionComplianceReportTaskResponse) => void): grpcWeb.ClientReadableStream<compliance_report_pb.StartPageSectionComplianceReportTaskResponse>;

  startPageSectionComplianceReportTask(
    request: compliance_report_pb.StartPageSectionComplianceReportTaskRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: compliance_report_pb.StartPageSectionComplianceReportTaskResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/StartPageSectionComplianceReportTask',
        request,
        metadata || {},
        this.methodDescriptorStartPageSectionComplianceReportTask,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanReviewService/StartPageSectionComplianceReportTask',
    request,
    metadata || {},
    this.methodDescriptorStartPageSectionComplianceReportTask);
  }

}

export class CatGraphServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetCatGraph = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.CatGraphService/GetCatGraph',
    grpcWeb.MethodType.UNARY,
    cat_graph_pb.GetCatGraphRequest,
    cat_graph_pb.CatGraph,
    (request: cat_graph_pb.GetCatGraphRequest) => {
      return request.serializeBinary();
    },
    cat_graph_pb.CatGraph.deserializeBinary
  );

  getCatGraph(
    request: cat_graph_pb.GetCatGraphRequest,
    metadata?: grpcWeb.Metadata | null): Promise<cat_graph_pb.CatGraph>;

  getCatGraph(
    request: cat_graph_pb.GetCatGraphRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: cat_graph_pb.CatGraph) => void): grpcWeb.ClientReadableStream<cat_graph_pb.CatGraph>;

  getCatGraph(
    request: cat_graph_pb.GetCatGraphRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: cat_graph_pb.CatGraph) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.CatGraphService/GetCatGraph',
        request,
        metadata || {},
        this.methodDescriptorGetCatGraph,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.CatGraphService/GetCatGraph',
    request,
    metadata || {},
    this.methodDescriptorGetCatGraph);
  }

  methodDescriptorGetCatGraphPicture = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.CatGraphService/GetCatGraphPicture',
    grpcWeb.MethodType.UNARY,
    cat_graph_pb.GetCatGraphRequest,
    cat_graph_pb.CatGraphPicture,
    (request: cat_graph_pb.GetCatGraphRequest) => {
      return request.serializeBinary();
    },
    cat_graph_pb.CatGraphPicture.deserializeBinary
  );

  getCatGraphPicture(
    request: cat_graph_pb.GetCatGraphRequest,
    metadata?: grpcWeb.Metadata | null): Promise<cat_graph_pb.CatGraphPicture>;

  getCatGraphPicture(
    request: cat_graph_pb.GetCatGraphRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: cat_graph_pb.CatGraphPicture) => void): grpcWeb.ClientReadableStream<cat_graph_pb.CatGraphPicture>;

  getCatGraphPicture(
    request: cat_graph_pb.GetCatGraphRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: cat_graph_pb.CatGraphPicture) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.CatGraphService/GetCatGraphPicture',
        request,
        metadata || {},
        this.methodDescriptorGetCatGraphPicture,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.CatGraphService/GetCatGraphPicture',
    request,
    metadata || {},
    this.methodDescriptorGetCatGraphPicture);
  }

  methodDescriptorListCatGraphs = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.CatGraphService/ListCatGraphs',
    grpcWeb.MethodType.UNARY,
    cat_graph_pb.ListCatGraphsRequest,
    cat_graph_pb.ListCatGraphsResponse,
    (request: cat_graph_pb.ListCatGraphsRequest) => {
      return request.serializeBinary();
    },
    cat_graph_pb.ListCatGraphsResponse.deserializeBinary
  );

  listCatGraphs(
    request: cat_graph_pb.ListCatGraphsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<cat_graph_pb.ListCatGraphsResponse>;

  listCatGraphs(
    request: cat_graph_pb.ListCatGraphsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: cat_graph_pb.ListCatGraphsResponse) => void): grpcWeb.ClientReadableStream<cat_graph_pb.ListCatGraphsResponse>;

  listCatGraphs(
    request: cat_graph_pb.ListCatGraphsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: cat_graph_pb.ListCatGraphsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.CatGraphService/ListCatGraphs',
        request,
        metadata || {},
        this.methodDescriptorListCatGraphs,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.CatGraphService/ListCatGraphs',
    request,
    metadata || {},
    this.methodDescriptorListCatGraphs);
  }

}

export class ReviewFindingVideoServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorStartFindingVideo = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ReviewFindingVideoService/StartFindingVideo',
    grpcWeb.MethodType.UNARY,
    finding_video_pb.StartFindingVideoRequest,
    finding_video_pb.StartFindingVideoResponse,
    (request: finding_video_pb.StartFindingVideoRequest) => {
      return request.serializeBinary();
    },
    finding_video_pb.StartFindingVideoResponse.deserializeBinary
  );

  startFindingVideo(
    request: finding_video_pb.StartFindingVideoRequest,
    metadata?: grpcWeb.Metadata | null): Promise<finding_video_pb.StartFindingVideoResponse>;

  startFindingVideo(
    request: finding_video_pb.StartFindingVideoRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: finding_video_pb.StartFindingVideoResponse) => void): grpcWeb.ClientReadableStream<finding_video_pb.StartFindingVideoResponse>;

  startFindingVideo(
    request: finding_video_pb.StartFindingVideoRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: finding_video_pb.StartFindingVideoResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ReviewFindingVideoService/StartFindingVideo',
        request,
        metadata || {},
        this.methodDescriptorStartFindingVideo,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ReviewFindingVideoService/StartFindingVideo',
    request,
    metadata || {},
    this.methodDescriptorStartFindingVideo);
  }

  methodDescriptorGetFindingVideo = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ReviewFindingVideoService/GetFindingVideo',
    grpcWeb.MethodType.UNARY,
    finding_video_pb.GetFindingVideoRequest,
    finding_video_pb.GetFindingVideoResponse,
    (request: finding_video_pb.GetFindingVideoRequest) => {
      return request.serializeBinary();
    },
    finding_video_pb.GetFindingVideoResponse.deserializeBinary
  );

  getFindingVideo(
    request: finding_video_pb.GetFindingVideoRequest,
    metadata?: grpcWeb.Metadata | null): Promise<finding_video_pb.GetFindingVideoResponse>;

  getFindingVideo(
    request: finding_video_pb.GetFindingVideoRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: finding_video_pb.GetFindingVideoResponse) => void): grpcWeb.ClientReadableStream<finding_video_pb.GetFindingVideoResponse>;

  getFindingVideo(
    request: finding_video_pb.GetFindingVideoRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: finding_video_pb.GetFindingVideoResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ReviewFindingVideoService/GetFindingVideo',
        request,
        metadata || {},
        this.methodDescriptorGetFindingVideo,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ReviewFindingVideoService/GetFindingVideo',
    request,
    metadata || {},
    this.methodDescriptorGetFindingVideo);
  }

  methodDescriptorCancelFindingVideo = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ReviewFindingVideoService/CancelFindingVideo',
    grpcWeb.MethodType.UNARY,
    finding_video_pb.CancelFindingVideoRequest,
    finding_video_pb.CancelFindingVideoResponse,
    (request: finding_video_pb.CancelFindingVideoRequest) => {
      return request.serializeBinary();
    },
    finding_video_pb.CancelFindingVideoResponse.deserializeBinary
  );

  cancelFindingVideo(
    request: finding_video_pb.CancelFindingVideoRequest,
    metadata?: grpcWeb.Metadata | null): Promise<finding_video_pb.CancelFindingVideoResponse>;

  cancelFindingVideo(
    request: finding_video_pb.CancelFindingVideoRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: finding_video_pb.CancelFindingVideoResponse) => void): grpcWeb.ClientReadableStream<finding_video_pb.CancelFindingVideoResponse>;

  cancelFindingVideo(
    request: finding_video_pb.CancelFindingVideoRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: finding_video_pb.CancelFindingVideoResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ReviewFindingVideoService/CancelFindingVideo',
        request,
        metadata || {},
        this.methodDescriptorCancelFindingVideo,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ReviewFindingVideoService/CancelFindingVideo',
    request,
    metadata || {},
    this.methodDescriptorCancelFindingVideo);
  }

}

export class ComplianceCodeSearchServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetIccCodeSearchResults = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ComplianceCodeSearchService/GetIccCodeSearchResults',
    grpcWeb.MethodType.UNARY,
    api_pb.GetIccCodeSearchResultsRequest,
    api_pb.GetIccCodeSearchResultsResponse,
    (request: api_pb.GetIccCodeSearchResultsRequest) => {
      return request.serializeBinary();
    },
    api_pb.GetIccCodeSearchResultsResponse.deserializeBinary
  );

  getIccCodeSearchResults(
    request: api_pb.GetIccCodeSearchResultsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.GetIccCodeSearchResultsResponse>;

  getIccCodeSearchResults(
    request: api_pb.GetIccCodeSearchResultsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.GetIccCodeSearchResultsResponse) => void): grpcWeb.ClientReadableStream<api_pb.GetIccCodeSearchResultsResponse>;

  getIccCodeSearchResults(
    request: api_pb.GetIccCodeSearchResultsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.GetIccCodeSearchResultsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ComplianceCodeSearchService/GetIccCodeSearchResults',
        request,
        metadata || {},
        this.methodDescriptorGetIccCodeSearchResults,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ComplianceCodeSearchService/GetIccCodeSearchResults',
    request,
    metadata || {},
    this.methodDescriptorGetIccCodeSearchResults);
  }

}

export class RegionNavigationServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetRegionTranscript = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.RegionNavigationService/GetRegionTranscript',
    grpcWeb.MethodType.UNARY,
    api_pb.GetRegionTranscriptRequest,
    api_pb.GetRegionTranscriptResponse,
    (request: api_pb.GetRegionTranscriptRequest) => {
      return request.serializeBinary();
    },
    api_pb.GetRegionTranscriptResponse.deserializeBinary
  );

  getRegionTranscript(
    request: api_pb.GetRegionTranscriptRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.GetRegionTranscriptResponse>;

  getRegionTranscript(
    request: api_pb.GetRegionTranscriptRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.GetRegionTranscriptResponse) => void): grpcWeb.ClientReadableStream<api_pb.GetRegionTranscriptResponse>;

  getRegionTranscript(
    request: api_pb.GetRegionTranscriptRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.GetRegionTranscriptResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.RegionNavigationService/GetRegionTranscript',
        request,
        metadata || {},
        this.methodDescriptorGetRegionTranscript,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.RegionNavigationService/GetRegionTranscript',
    request,
    metadata || {},
    this.methodDescriptorGetRegionTranscript);
  }

  methodDescriptorGetRegionCrop = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.RegionNavigationService/GetRegionCrop',
    grpcWeb.MethodType.UNARY,
    api_pb.GetRegionCropRequest,
    api_pb.GetRegionCropResponse,
    (request: api_pb.GetRegionCropRequest) => {
      return request.serializeBinary();
    },
    api_pb.GetRegionCropResponse.deserializeBinary
  );

  getRegionCrop(
    request: api_pb.GetRegionCropRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.GetRegionCropResponse>;

  getRegionCrop(
    request: api_pb.GetRegionCropRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.GetRegionCropResponse) => void): grpcWeb.ClientReadableStream<api_pb.GetRegionCropResponse>;

  getRegionCrop(
    request: api_pb.GetRegionCropRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.GetRegionCropResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.RegionNavigationService/GetRegionCrop',
        request,
        metadata || {},
        this.methodDescriptorGetRegionCrop,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.RegionNavigationService/GetRegionCrop',
    request,
    metadata || {},
    this.methodDescriptorGetRegionCrop);
  }

  methodDescriptorGetPageCrop = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.RegionNavigationService/GetPageCrop',
    grpcWeb.MethodType.UNARY,
    api_pb.GetPageCropRequest,
    api_pb.GetPageCropResponse,
    (request: api_pb.GetPageCropRequest) => {
      return request.serializeBinary();
    },
    api_pb.GetPageCropResponse.deserializeBinary
  );

  getPageCrop(
    request: api_pb.GetPageCropRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.GetPageCropResponse>;

  getPageCrop(
    request: api_pb.GetPageCropRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.GetPageCropResponse) => void): grpcWeb.ClientReadableStream<api_pb.GetPageCropResponse>;

  getPageCrop(
    request: api_pb.GetPageCropRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.GetPageCropResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.RegionNavigationService/GetPageCrop',
        request,
        metadata || {},
        this.methodDescriptorGetPageCrop,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.RegionNavigationService/GetPageCrop',
    request,
    metadata || {},
    this.methodDescriptorGetPageCrop);
  }

  methodDescriptorListRegionChildren = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.RegionNavigationService/ListRegionChildren',
    grpcWeb.MethodType.UNARY,
    api_pb.ListRegionChildrenRequest,
    api_pb.ListRegionChildrenResponse,
    (request: api_pb.ListRegionChildrenRequest) => {
      return request.serializeBinary();
    },
    api_pb.ListRegionChildrenResponse.deserializeBinary
  );

  listRegionChildren(
    request: api_pb.ListRegionChildrenRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.ListRegionChildrenResponse>;

  listRegionChildren(
    request: api_pb.ListRegionChildrenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.ListRegionChildrenResponse) => void): grpcWeb.ClientReadableStream<api_pb.ListRegionChildrenResponse>;

  listRegionChildren(
    request: api_pb.ListRegionChildrenRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.ListRegionChildrenResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.RegionNavigationService/ListRegionChildren',
        request,
        metadata || {},
        this.methodDescriptorListRegionChildren,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.RegionNavigationService/ListRegionChildren',
    request,
    metadata || {},
    this.methodDescriptorListRegionChildren);
  }

  methodDescriptorGetPageSummary = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.RegionNavigationService/GetPageSummary',
    grpcWeb.MethodType.UNARY,
    api_pb.GetPageSummaryRequest,
    api_pb.GetPageSummaryResponse,
    (request: api_pb.GetPageSummaryRequest) => {
      return request.serializeBinary();
    },
    api_pb.GetPageSummaryResponse.deserializeBinary
  );

  getPageSummary(
    request: api_pb.GetPageSummaryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.GetPageSummaryResponse>;

  getPageSummary(
    request: api_pb.GetPageSummaryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.GetPageSummaryResponse) => void): grpcWeb.ClientReadableStream<api_pb.GetPageSummaryResponse>;

  getPageSummary(
    request: api_pb.GetPageSummaryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.GetPageSummaryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.RegionNavigationService/GetPageSummary',
        request,
        metadata || {},
        this.methodDescriptorGetPageSummary,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.RegionNavigationService/GetPageSummary',
    request,
    metadata || {},
    this.methodDescriptorGetPageSummary);
  }

  methodDescriptorSearchPlanText = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.RegionNavigationService/SearchPlanText',
    grpcWeb.MethodType.UNARY,
    api_pb.SearchPlanTextRequest,
    api_pb.SearchPlanTextResponse,
    (request: api_pb.SearchPlanTextRequest) => {
      return request.serializeBinary();
    },
    api_pb.SearchPlanTextResponse.deserializeBinary
  );

  searchPlanText(
    request: api_pb.SearchPlanTextRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.SearchPlanTextResponse>;

  searchPlanText(
    request: api_pb.SearchPlanTextRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.SearchPlanTextResponse) => void): grpcWeb.ClientReadableStream<api_pb.SearchPlanTextResponse>;

  searchPlanText(
    request: api_pb.SearchPlanTextRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.SearchPlanTextResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.RegionNavigationService/SearchPlanText',
        request,
        metadata || {},
        this.methodDescriptorSearchPlanText,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.RegionNavigationService/SearchPlanText',
    request,
    metadata || {},
    this.methodDescriptorSearchPlanText);
  }

}

export class PassageSearchServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorSearchPlanPassages = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.PassageSearchService/SearchPlanPassages',
    grpcWeb.MethodType.UNARY,
    api_pb.SearchPlanPassagesRequest,
    api_pb.SearchPlanPassagesResponse,
    (request: api_pb.SearchPlanPassagesRequest) => {
      return request.serializeBinary();
    },
    api_pb.SearchPlanPassagesResponse.deserializeBinary
  );

  searchPlanPassages(
    request: api_pb.SearchPlanPassagesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<api_pb.SearchPlanPassagesResponse>;

  searchPlanPassages(
    request: api_pb.SearchPlanPassagesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: api_pb.SearchPlanPassagesResponse) => void): grpcWeb.ClientReadableStream<api_pb.SearchPlanPassagesResponse>;

  searchPlanPassages(
    request: api_pb.SearchPlanPassagesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: api_pb.SearchPlanPassagesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.PassageSearchService/SearchPlanPassages',
        request,
        metadata || {},
        this.methodDescriptorSearchPlanPassages,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.PassageSearchService/SearchPlanPassages',
    request,
    metadata || {},
    this.methodDescriptorSearchPlanPassages);
  }

}

